import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Typography, Autocomplete, createFilterOptions, ListItemText } from '@mui/material';
import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Municipio } from '../Municipios/Municipio';
import { MunicipioVariacion } from '../MunicipiosVariaciones/MunicipioVariacion';

export interface IRepairMunicipioProps {
    id: number;
    variacion: string;
    open: boolean;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairMunicipioState {
    data: any[];
    open: boolean;
}

export default class RepairMunicipio extends React.Component<IRepairMunicipioProps, IRepairMunicipioState> {
    _municipioVariacion: MunicipioVariacion = new MunicipioVariacion();
    _variacion: string = '';

    public constructor(props: IRepairMunicipioProps) {
        super(props);

        this.state = {
            data: [],
            open: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairMunicipioProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });

        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    {
                        `Reparar municipio`
                    }
                </DialogTitle>
                <DialogContent>
                    <Typography variant='body2'>
                        {
                            `Seleccione un municipio para asignar la variación ${this.props.variacion}`
                        }
                    </Typography>
                    <Autocomplete
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione un municipio" variant="standard" />
                        )}
                        onChange={(event: any, newValue: Municipio | null) => {
                            this._municipioVariacion.municipio = newValue?.nombre;
                        }}
                        options={this.state.data}
                        getOptionLabel={(option: Municipio) => option.nombre!}
                        filterOptions={createFilterOptions({
                            matchFrom: 'start',
                            stringify: (option) => option.nombre!
                        })} 
                        renderOption={(props, item) => (
                            <li {...props} key={item.id}>
                              <ListItemText>{item.nombre}</ListItemText>
                            </li>
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>Ok</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Save() {
        this._municipioVariacion.variacion = this.props.variacion;
        
        let url = `${Common.END_POINT}/masters/municipiosvariaciones`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._municipioVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {    
            if(this.props.onSave != null) {
                this.props.onSave(this.props.id);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            if(this.props.onSave != null) {
                this.props.onSave(this.props.id);
            }
        });
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }

    private Get(): void {
        let url = `${Common.END_POINT}/masters/municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: MunicipioVariacion[]) => {
            this.setState(
                {
                    data: response
                }
            );
        });
    }
}